const purchaseResumes = new Map();

export function saveArtworkPurchaseResume(artworkId, purchaseState) {
  if (!artworkId || !purchaseState) {
    return;
  }

  purchaseResumes.set(String(artworkId), purchaseState);
}

export function getArtworkPurchaseResume(artworkId) {
  if (!artworkId) {
    return null;
  }

  return purchaseResumes.get(String(artworkId)) ?? null;
}

export function clearArtworkPurchaseResume(artworkId) {
  if (artworkId) {
    purchaseResumes.delete(String(artworkId));
  }
}
